import {Component, Input, OnInit} from '@angular/core';
import {GlobalEventsService} from "../../services/global-events.service";
import {ToastData} from "../../common/classes";
import {DropDownAnimation} from "../../common/animations";

@Component({
  selector: 'app-toast-pop-up',
  templateUrl: './toast-pop-up.component.html',
  styleUrls: ['./toast-pop-up.component.scss'],
  animations: [DropDownAnimation]
})
export class ToastPopUpComponent implements OnInit {
  @Input() isOpen: boolean;
  @Input() title?: string;
  @Input() description?: string;
  @Input() buttonText?: any;
  @Input() onButtonClick?: any;
  @Input() notFadeOut?: boolean;
  private toastFadeDownTime = 10000;
  private toastTimeOut: any;
  public error: boolean | undefined;
  public success: boolean | undefined;
  constructor(
    private globalEventsService: GlobalEventsService
  ) {}

  ngOnInit(): void {
    this.globalEventsService.subscribe('top-toast', 'toast', (data: ToastData) => {
      clearTimeout(this.toastTimeOut);
      this.notFadeOut = data.notFadeOut;
      this.isOpen = data.isOpen;
      this.title = data.title;
      this.description = data.description;
      this.buttonText = data.buttonText;
      this.onButtonClick = data.onButtonClick;
      this.error = data.error;
      this.success = data.success;
      if (!this.notFadeOut) {
        this.toastTimeOut = setTimeout(() => {
          this.isOpen = false
        }, 10000)
      }
    })
  }

  public onCloseClick() {
    this.isOpen = false;
  }
}
